import React from 'react'
import resume from '../assets/Mohammed Arfa Uruj CV02112025.pdf'
import "./Work.css"
import roadmap from "../assets/road-map.jpg"
import styled from 'styled-components'
import hover from "../assets/hover.png"

function Work() {
    return (
        <div id="work">
            <IntroW>
                <h1>Check out my Work Experience!</h1>
            </IntroW>
            <ExpCont style={{ backgroundImage: roadmap }}>
                <div class="timeline">
                    <div class="container left">
                        <div class="content">
                            <section id="csusb-research-teaching-assistant">
                                <div className='work-entry'>
                                    <h2>Research Assistant & Teaching Assistant – California State University, San Bernardino</h2>
                                    <p><strong>San Bernardino, CA | August 2024 - Present</strong></p>
                                    <img src={hover} className='hoverimg' />
                                    <div className='work-details'>
                                        <p>As a <strong>Research Assistant & Teaching Assistant</strong> at CSUSB, I have been actively involved in
                                            <strong>mentoring, research execution, and software development</strong> across multiple advanced computing
                                            projects. My role includes leading research teams, guiding students in technical methodologies, and contributing
                                            to cutting-edge machine learning and high-performance computing (HPC) applications.</p>

                                        <h3>Key Responsibilities & Contributions:</h3>

                                        <h4>Research Leadership & Mentorship:</h4>
                                        <ul>
                                            <li>Led and mentored a <strong>team of 15 research assistants</strong> in diverse research areas, including:</li>
                                            <ul>
                                                <li><strong>Overfitting mitigation</strong> strategies in deep learning.</li>
                                                <li><strong>Image-based cancer detection</strong> using advanced AI techniques.</li>
                                                <li><strong>Enhancing Large Language Models (LLMs)</strong> with Retrieval-Augmented Generation (RAG).</li>
                                                <li><strong>Introducing High-Performance Computing (HPC)</strong> concepts to non-technical students.</li>
                                            </ul>
                                            <li>Guided the team in producing review papers to identify the most effective methodologies, culminating
                                                in <strong>acceptance at AIRC 2025</strong>.</li>
                                        </ul>

                                        <h4>Technical Research & Model Evaluation:</h4>
                                        <ul>
                                            <li>Directed the technical execution of research and development projects, evaluating <strong>30+ machine
                                                learning models</strong> and software architectures.</li>
                                            <li>Implemented <strong>cross-validation, stress testing, and optimization techniques</strong> to select
                                                top-performing models for real-world deployment.</li>
                                            <li>Explored and compared various <strong>deep learning and computer vision</strong> approaches to enhance
                                                the accuracy and efficiency of AI-driven solutions.</li>
                                        </ul>

                                        <h4>Software Development & Teaching Contributions:</h4>
                                        <ul>
                                            <li>Designed and implemented <strong>scalable software solutions</strong> to support research in AI,
                                                machine learning, and HPC.</li>
                                            <li>Mentored students in <strong>algorithm optimization, debugging, and software engineering best practices</strong>
                                                to ensure high-performance applications and reproducible research outcomes.</li>
                                            <li>Provided hands-on instruction and technical support, equipping students with the necessary tools to
                                                <strong>develop and deploy AI-driven solutions</strong> effectively.</li>
                                        </ul>

                                        <p>This experience has strengthened my expertise in <strong>machine learning research, AI model evaluation,
                                            HPC applications, software engineering, and academic mentoring</strong>, allowing me to make meaningful
                                            contributions to both research and education.</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="container right">
                        <div class="content">
                            <section id="fin-tastic-division">
                                <div className='work-entry'>
                                    <h2>Project Manager – Fin-tastic Division (Class Project)</h2>
                                    <p><strong>San Bernardino, CA | January 2024 - May 2024</strong></p>
                                    <img src={hover} className='hoverimg' />
                                    <div className='work-details'>
                                        <p>As the <strong>Project Manager</strong> for the Fin-tastic Division, I led the development and successful
                                            launch of a <strong>mobile math game for kids</strong> on the <strong>Amazon Appstore</strong>. This project
                                            integrated a combination of <strong>game development, cloud computing, and agile methodologies</strong> to
                                            ensure a seamless and engaging user experience.</p>

                                        <h3>Key Responsibilities & Contributions:</h3>

                                        <h4>Mobile Game Development & Deployment:</h4>
                                        <ul>
                                            <li>Managed the end-to-end development of a <strong>mobile math game</strong> designed to enhance
                                                children’s learning experiences.</li>
                                            <li>Utilized <strong>Unity</strong> and <strong>C#</strong> to develop and optimize game mechanics and
                                                animations.</li>
                                            <li>Integrated <strong>Google AdMob</strong> for in-app advertising, enabling monetization while maintaining
                                                a user-friendly experience.</li>
                                        </ul>

                                        <h4>Cloud-Based Database & Account Management:</h4>
                                        <ul>
                                            <li>Designed a scalable <strong>Azure App Services</strong> and <strong>Azure Functions</strong> solution
                                                for seamless user data storage.</li>
                                            <li>Implemented an <strong>account transfer functionality</strong>, allowing users to securely retrieve and
                                                sync game progress across multiple devices.</li>
                                        </ul>

                                        <h4>Agile Project Management & Collaboration:</h4>
                                        <ul>
                                            <li>Employed <strong>agile project management</strong> techniques to ensure efficient development and delivery.</li>
                                            <li>Facilitated <strong>weekly Scrum meetings</strong> to track progress, address challenges, and align
                                                team efforts with project milestones.</li>
                                            <li>Utilized <strong>Azure DevOps</strong> and <strong>GitHub</strong> for version control, collaboration,
                                                and continuous integration.</li>
                                        </ul>

                                        <p>This project honed my skills in <strong>game development, cloud computing, agile methodologies, and leadership</strong>,
                                            equipping me with hands-on experience in managing technical teams and delivering innovative solutions.</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="container left">
                        <div class="content">
                            <section id="astute-solutions-intern">
                                <div className='work-entry'>
                                    <h2>Software Engineering Intern – Astute Solutions LLC</h2>
                                    <p><strong>Folsom, CA | April 2023 - July 2023</strong></p>
                                    <img src={hover} className='hoverimg' />
                                    <div className='work-details'>
                                        <p>As a <strong>Software Engineering Intern</strong> at Astute Solutions LLC, I played a key role in developing
                                            and optimizing a <strong>full-stack web application</strong> using modern web technologies. My contributions
                                            focused on <strong>frontend performance optimization, backend API development, and database efficiency</strong>,
                                            leading to improved user experience and system functionality.</p>

                                        <h3>Key Responsibilities & Contributions:</h3>

                                        <h4>Full-Stack Web Application Development:</h4>
                                        <ul>
                                            <li>Designed and developed a <strong>React.js frontend</strong> with an intuitive user interface,
                                                improving performance and user experience by <strong>20%</strong>.</li>
                                            <li>Built a scalable <strong>Node.js backend</strong> to handle business logic and optimize application responsiveness.</li>
                                        </ul>

                                        <h4>API Integration & System Functionality:</h4>
                                        <ul>
                                            <li>Implemented <strong>RESTful APIs</strong> to streamline data exchange between the frontend and backend,
                                                enhancing system interoperability.</li>
                                            <li>Designed efficient API endpoints to support real-time data retrieval and dynamic content rendering.</li>
                                        </ul>

                                        <h4>Database Optimization & Performance Tuning:</h4>
                                        <ul>
                                            <li>Utilized <strong>MongoDB</strong> as the primary database for scalable and efficient data storage.</li>
                                            <li>Optimized database queries and indexing strategies, reducing data retrieval load times by <strong>15%</strong>.</li>
                                        </ul>

                                        <p>This experience enhanced my expertise in <strong>React.js, Node.js, RESTful API development, and MongoDB</strong>,
                                            reinforcing my ability to develop high-performance web applications.</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="container right">
                        <div class="content">
                            <section id="ideacentrix-intern">
                                <div className='work-entry'>
                                    <h2>Software Engineering Intern – Ideacentrix</h2>
                                    <p><strong>Plano, TX | Jan 2022 - Dec 2022</strong></p>
                                    <img src={hover} className='hoverimg' />
                                    <div className='work-details'>
                                        <p>As a <strong>Software Engineering Intern</strong> at Ideacentrix, I contributed to the development of an
                                            <strong>AI-driven monitoring platform</strong> designed to optimize gas utility usage for SoCalGas. My role
                                            focused on <strong>time-series anomaly detection, cloud-based data security, and real-time analytics</strong>,
                                            leveraging AWS and AngularJS to enhance operational efficiency.</p>

                                        <h3>Key Responsibilities & Contributions:</h3>

                                        <h4>AI-Driven Utility Monitoring & Anomaly Detection:</h4>
                                        <ul>
                                            <li>Developed a <strong>time-series anomaly detection model</strong> to predict and flag gas wastage,
                                                reducing waste by <strong>30%</strong>.</li>
                                            <li>Integrated AI-driven analytics to automate real-time detection of inefficiencies in gas consumption.</li>
                                            <li>Designed an intuitive <strong>AngularJS-based front end</strong> for seamless data visualization and
                                                user interaction.</li>
                                        </ul>

                                        <h4>Cloud Security & Data Encryption:</h4>
                                        <ul>
                                            <li>Implemented secure, <strong>AES-encrypted data transfers</strong> between the front end and the
                                                <strong>AWS back end</strong> to ensure <strong>100% data integrity</strong>.</li>
                                            <li>Developed a robust cloud architecture in compliance with <strong>CPUC regulations</strong> for
                                                gas safety and utility monitoring.</li>
                                        </ul>

                                        <h4>Data Visualization & Operational Insights:</h4>
                                        <ul>
                                            <li>Designed and deployed <strong>interactive dashboards</strong> displaying real-time gas usage trends,
                                                wastage heatmaps, and compliance status for SoCalGas.</li>
                                            <li>Enabled utility teams to detect inefficiencies in real-time, reducing wastage response times by <strong>40%</strong>.</li>
                                        </ul>

                                        <h4>Collaboration & AWS Ecosystem Development:</h4>
                                        <ul>
                                            <li>Worked with <strong>cross-functional teams</strong> to develop, optimize, and debug software
                                                solutions within the <strong>AWS ecosystem</strong>.</li>
                                            <li>Enhanced cloud-based application performance by implementing <strong>AWS best practices</strong> for
                                                security and scalability.</li>
                                            <li>Refined technical problem-solving and project planning skills in a dynamic cloud engineering
                                                environment.</li>
                                        </ul>

                                        <p>This experience strengthened my expertise in <strong>AI-based anomaly detection, cloud security, data encryption,
                                            and real-time analytics</strong>, preparing me for advanced roles in software and cloud engineering.</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="container left">
                        <div class="content">
                            <section id="mobisprint-alexa-developer">
                                <div className='work-entry'>
                                    <h2>Alexa Skills Developer – MobiSprint</h2>
                                    <p><strong>January 2022</strong></p>
                                    <img src={hover} className='hoverimg' />
                                    <div className='work-details'>
                                        <p>As an <strong>Alexa Skills Developer</strong> at MobiSprint, I designed and developed <strong>voice-activated
                                            skills</strong> for Amazon's virtual assistant, focusing on <strong>Voice User Interface (VUI) design,
                                                coding, and user experience optimization</strong>. My work involved creating interactive and intuitive voice
                                            applications that enhanced user engagement and accessibility.</p>

                                        <h3>Key Responsibilities & Contributions:</h3>

                                        <h4>Voice Application Development:</h4>
                                        <ul>
                                            <li>Designed and built <strong>custom Alexa skills</strong> to provide seamless user interactions with Amazon Echo
                                                and other Alexa-enabled devices.</li>
                                            <li>Implemented <strong>natural language processing (NLP)</strong> techniques to enhance conversation flow
                                                and improve speech recognition accuracy.</li>
                                            <li>Developed and tested <strong>serverless applications</strong> using AWS Lambda and Node.js to handle Alexa
                                                skill requests efficiently.</li>
                                        </ul>

                                        <h4>VUI Design & Optimization:</h4>
                                        <ul>
                                            <li>Applied <strong>best practices in Voice User Interface (VUI) design</strong> to create intuitive and
                                                engaging conversational experiences.</li>
                                            <li>Optimized voice commands and intents to ensure a smooth and natural interaction between users and the
                                                virtual assistant.</li>
                                            <li>Integrated <strong>AI-driven personalization</strong> to improve responses and enhance user satisfaction.</li>
                                        </ul>

                                        <h4>Collaboration & Impact:</h4>
                                        <ul>
                                            <li>Worked closely with <strong>cross-functional teams</strong>, including designers and AI engineers, to
                                                develop high-quality voice applications.</li>
                                            <li>Conducted <strong>usability testing</strong> and iterative refinements to enhance skill responsiveness
                                                and user engagement.</li>
                                            <li>Strengthened expertise in <strong>voice technology, AI-driven interaction design, and speech-based UI</strong>,
                                                positioning myself as a valuable asset in voice application development roles.</li>
                                        </ul>

                                        <p>This experience deepened my understanding of <strong>voice-first technology, NLP, serverless architecture,
                                            and AI-driven UI</strong>, enabling me to create highly interactive and user-friendly Alexa skills.</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="container right">
                        <div class="content">
                            <section id="bookspud-tech-lead">
                                <div className='work-entry'>
                                    <h2>Technical Lead – BooksPUD</h2>
                                    <p><strong>Hyderabad, Telangana | December 2019 - November 2021</strong></p>
                                    <img src={hover} className='hoverimg' />
                                    <div className='work-details'>
                                        <p>As a <strong>Technical Lead</strong> at BooksPUD, a startup specializing in second-hand book sales, I led
                                            the development of a <strong>custom e-commerce platform</strong> for book vendors across India. My role involved
                                            <strong>software architecture, team leadership, backend development, and AI-driven recommendation systems</strong>,
                                            enabling seamless digital transformation for traditional bookstores.</p>

                                        <h3>Key Responsibilities & Contributions:</h3>

                                        <h4>Platform Development & Scalability:</h4>
                                        <ul>
                                            <li>Architected and developed an <strong>e-commerce platform</strong> that increased
                                                <strong>monthly user traffic by 150%</strong>, reaching <strong>1000+ active users</strong> within the first year.</li>
                                            <li>Designed a robust <strong>Node.js back end</strong> with <strong>RESTful APIs</strong> for efficient data management
                                                and seamless integration with Firebase-hosted front-end services.</li>
                                            <li>Optimized the platform’s database by applying <strong>SQLite in Third Normal Form (3NF)</strong> with indexing,
                                                reducing operational costs by <strong>90%</strong>.</li>
                                        </ul>

                                        <h4>AI-Powered Recommendation Engine:</h4>
                                        <ul>
                                            <li>Developed a <strong>personalized recommendation system</strong> using the
                                                <strong>Surprise and Neural Collaborative Filtering (NCF) libraries</strong> to enhance user engagement.</li>
                                            <li>Implemented a content-based and collaborative filtering approach that improved
                                                <strong>average session time by 50%</strong> and increased conversions by <strong>20%</strong>.</li>
                                        </ul>

                                        <h4>Leadership & Digital Transformation:</h4>
                                        <ul>
                                            <li>Managed a <strong>cross-functional development team</strong>, overseeing project roadmaps and agile workflows.</li>
                                            <li>Collaborated with <strong>stakeholders, book vendors, and digital partners</strong> to enhance platform features
                                                and ensure a seamless user experience.</li>
                                            <li>Led the <strong>digitization of traditional bookstores</strong>, expanding market reach and improving accessibility
                                                for book enthusiasts across India.</li>
                                        </ul>

                                        <p>Through this role, I gained hands-on experience in <strong>software scalability, AI-driven personalization,
                                            e-commerce strategies, and leadership</strong> in a fast-paced startup environment.</p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </ExpCont>
            <ResumeCont>
                <div>
                    Check out My Resume!
                </div>
                <button>
                    <a href={resume} download={resume}>Grab A Copy</a>
                </button>
            </ResumeCont>
        </div>
    )
}

export default Work

const IntroW = styled.div`
    color: white;
    background: linear-gradient(#107896,#43abc9);
    padding-top: 8vh;
    padding-bottom: 5vh;
`

const ExpCont = styled.div`
    background-image: url(${roadmap});
    background-size: cover;
    div{
        padding: 2vh;
    }
`

const ResumeCont = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5vh;
    div{
        margin-bottom: 5vh;
        font-size: 3em;
        color: white;
        @media(max-width: 767px){
            font-size: 1.5em;
        }
        @media(max-width: 281px){
            font-size: 1em;
        }
    }
    button{
        background: none;
        border: 3px solid rgb(221, 221, 221);
        padding: 2vh 5vh;
        &:hover{
            cursor: pointer;
            background: rgb(255, 255, 255, 0.2);
            padding: 2vh 6vh;
        }
    }
    a{
        text-decoration: none;
        color: rgb(221, 221, 221);
        font-size: 16px;
    }
`